<template>
  <OverviewTab
    :market="market"
    :initial-fields="initialFields"
    :services="services"
    :title="titlePackage"
    :intro="intro"
  />
</template>

<script setup lang="ts">
import OverviewTab from '~/components/sustainability/OverviewTab.vue'
import type { TMarketServiceConfig } from '~/src/types/markets'

/*-------------------------------------
  Constants
-------------------------------------*/
const intro = {
  title:
    'Benchmark’s Cobalt ESG Report is an annual subscription with quarterly updates.',
  body: [
    'Benchmark’s Cobalt ESG Report is an annual subscription with quarterly updates.',
    'The report offers comprehensive coverage of the evolving ESG landscape in the upstream cobalt supply chain, forecasted trends and our Benchmark Global LCAs, which measure the environmental impact of producing both cobalt metal and cobalt sulphate.',
    'To keep subscribers up to date, the report contains individual assessments of all cobalt miners and converters, with indicators measuring ESG performance alongside index ratings allocated based on our Benchmark’s Sustainability Index. Utilising data collected through Benchmark’s independent research and analysis, this report provides detailed and expert ESG assessment and monitoring of the cobalt industry.',
  ],
  images: {
    one: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346124/assets/market/cobalt/cobalt-1_huvz00.jpg',
      alt: 'Cobalt Forecasts',
    },
    two: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346125/assets/market/cobalt/cobalt-2_buia0t.jpg',
      alt: 'Cobalt Forecasts',
    },
    three: {
      url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346124/assets/market/cobalt/cobalt-3_s7urso.jpg',
      alt: 'Cobalt Forecasts',
    },
  },
}

const services = [
  {
    icon: 'services/icon-success-chart',
    description: 'Company-by-company ESG database',
  },
  {
    icon: 'services/icon-presentation',
    description: 'Materiality assessment and critical ESG analysis',
  },
  {
    icon: 'services/icon-eco-earth',
    description: 'Benchmark Global Cobalt LCA',
  },
  {
    icon: 'services/icon-consultancy',
    description: 'ESG news brief and global policy review',
  },
  {
    icon: 'services/icon-idea',
    description: 'Access to Benchmark’s analysts',
  },
]

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({
  isTab: true,
  scrollToTop: false,
  middleware: 'redirect-tab',
})

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  market: TMarketServiceConfig
  initialFields: string[]
}>()

const titlePackage = ref(`${props.market.name} ESG Report`)
</script>
